"use client";

import React from "react";

const FluorideIntro: React.FC = () => {
  return (
    <div className="w-full py-6 sm:py-8 ">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2 className="text-2xl sm:text-3xl font-semibold text-gray-800 text-center pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2 after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]">
          Protecting Your Teeth: The Importance of Fluoride Treatment
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed">
          In our daily lives, we often overlook the importance of maintaining our oral health. We brush and floss regularly, but sometimes that&#39;s not enough to protect our teeth from decay. That&#39;s where fluoride comes in – a natural mineral that plays a crucial role in safeguarding our teeth and preventing cavities. Let&#39;s explore this essential aspect of dental care together.
        </p>
      </div>
    </div>
  );
};

export default FluorideIntro;